/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/*------------------------------------------------------------------------------------------------------------
custom js of the country code select on the dropdown of the register form by the cusotmer login of 11-02-2023
-------------------------------------------------------------------------------------------------------------*/

/* $(document).ready(function(){
  $('select.custom_phone_country_code').change(function(){
    //alert('hello');
    var option_data = $(this).val();
     $("#custom_phone_number").keyup(function() {
    var text =$(this).val();
       $("#phone_number").val(option_data +text);
  });
  });
}); */

function changeScreenProtector(element) {
  if (element.hasAttribute("product-id")) {
    document.querySelector(".custom-product-quantity").value = 1;
    document.querySelector(".custom-product-id").value = element.getAttribute("product-id");
  } else {
    document.querySelector(".custom-product-quantity").value = 0;
  }
}

function chooseScreenProtector(element) {
  var currentScreenShield = ".shield-product-quantity-" + element.getAttribute('product-id');
  if (element.checked) {   
    document.querySelector("" + currentScreenShield + "").value = 1;
  } else {
    document.querySelector("" + currentScreenShield + "").value = 0;
  }
}


function showProShockDescription() {
  let rootElement = document.querySelector(":root");
  rootElement.style.setProperty("--product-main-color", "black");
  rootElement.style.setProperty("--product-secondary-color", "#72F05F");
  rootElement.style.setProperty("--selector-color", "#72F05F");
  rootElement.style.setProperty("--purchase-button", "black");
  rootElement.style.setProperty("--purchase-button-shadow", "#72F05F");
  rootElement.style.setProperty("--custom-menu-background-color", "#F4F4F4");
  rootElement.style.setProperty("--custom-selector-color", "#EFEFEF");
  rootElement.style.setProperty("--custom-selector-border", "#CCCCCC");
  let allProDescriptionDiv = document.querySelectorAll(".pro-shock-show");
  let allFullDescriptionDiv = document.querySelectorAll(".full-shock-show");
  for (let i = 0; i < allProDescriptionDiv.length; i++) {
    if (allProDescriptionDiv[i].classList.contains("product-bundle-item-info") || allProDescriptionDiv[i].classList.contains("bundle-product-item") || allProDescriptionDiv[i].classList.contains("bundle-block-item-info")) {
      allProDescriptionDiv[i].style.display = "flex";
    } else {
      allProDescriptionDiv[i].style.display = "block";
    }
  }
  for (let i = 0; i < allFullDescriptionDiv.length; i++) {
    allFullDescriptionDiv[i].style.display = "none";
  }
  if (document.querySelector("[probundleid]")) {
    document.querySelector("[probundleid]").value = document.querySelector("[probundleid]").getAttribute("probundleid");
    document.querySelector("[proBundleType]").value = document.querySelector("[proBundleType]").getAttribute("proBundleType");
    document.querySelector("[proBundleType]").setAttribute("prevSelected", "Pro-Pack-EU");
    document.querySelector("#bundle-block-item-checkbox").classList.add("checkbox-with-black-icon");
  }
  document.querySelectorAll(".screen-shield-checkbox-small").forEach((element) => {
    element.classList.add("checkbox-with-green-icon");
  });
  document.querySelectorAll(".custom-accessories-input").forEach((element) => {
    element.classList.add("checkbox-with-green-icon");
  });
  document.querySelectorAll("#promotional-product-checbox").forEach((element) => {
    element.classList.add("checkbox-with-black-icon");
  });
}

function showFullShockDescription() {
  let rootElement = document.querySelector(":root");
  rootElement.style.setProperty("--product-main-color", "#8800FF");
  rootElement.style.setProperty("--product-secondary-color", "white");
  rootElement.style.setProperty("--selector-color", "#8800FF");
  rootElement.style.setProperty("--purchase-button", "black");
  rootElement.style.setProperty("--purchase-button-shadow", "#8800FF");
  rootElement.style.setProperty("--custom-menu-background-color", "white");
  rootElement.style.setProperty("--custom-selector-color", "white");
  rootElement.style.setProperty("--custom-selector-border", "black");
  let allProDescriptionDiv = document.querySelectorAll(".pro-shock-show");
  let allFullDescriptionDiv = document.querySelectorAll(".full-shock-show");
  for (let i = 0; i < allProDescriptionDiv.length; i++) {
    allProDescriptionDiv[i].style.display = "none";
  }
  for (let i = 0; i < allFullDescriptionDiv.length; i++) {
    if (allFullDescriptionDiv[i].classList.contains("product-bundle-item-info") || allFullDescriptionDiv[i].classList.contains("bundle-product-item") || allFullDescriptionDiv[i].classList.contains("bundle-block-item-info")) {
      allFullDescriptionDiv[i].style.display = "flex";
    } else {
      allFullDescriptionDiv[i].style.display = "block";
    }
  }
  if (document.querySelector("[fullbundleid]")) {
    document.querySelector("[fullbundleid]").value = document.querySelector("[fullbundleid]").getAttribute("fullbundleid");
    document.querySelector("[fullBundleType]").value = document.querySelector("[fullBundleType]").getAttribute("fullBundleType");
    document.querySelector("[proBundleType]").setAttribute("prevSelected", "Full-Pack-EU");
    document.querySelector("#bundle-block-item-checkbox").classList.remove("checkbox-with-black-icon");
  }
  document.querySelectorAll(".screen-shield-checkbox-small").forEach((element) => {
    element.classList.remove("checkbox-with-green-icon");
  });
  document.querySelectorAll(".custom-accessories-input").forEach((element) => {
    element.classList.remove("checkbox-with-green-icon");
  });
  document.querySelectorAll("#promotional-product-checbox").forEach((element) => {
    element.classList.remove("checkbox-with-black-icon");
  });
}

function changeProductCardPrice(element) {
  let parentElement = element.closest(".product-item");
  if (element.getAttribute("data-item-compare-at-price")) {
    parentElement.querySelector(".price--compare").textContent = element.getAttribute("data-item-compare-at-price");
  }
  if (element.getAttribute("data-item-price")) {
    parentElement.querySelector(".price--highlight").textContent = element.getAttribute("data-item-price");
  }
}

function changeBundleQuantity() {
  if (document.querySelector("#bundle-block-item-checkbox").checked == true) {
    document.querySelector("[inputtype='bundle']").value = 1;
    document.querySelector("[name='properties[bundle]']").outerHTML = document.querySelector("[name='properties[bundle]']").outerHTML.replaceAll("disabledinput", "input");
    document.querySelector("[name='properties[bundle]']").value = document.querySelector("[name='properties[bundle]']").getAttribute("prevSelected");
  } else {
    document.querySelector("[inputtype='bundle']").value = 0;
    document.querySelector("[name='properties[bundle]']").outerHTML = document.querySelector("[name='properties[bundle]']").outerHTML.replaceAll("input", "disabledinput");
    document.querySelector("[name='properties[bundle]']").value = "";
  }
}

window.addEventListener("DOMContentLoaded", (event) => {
  var storedData = sessionStorage.getItem('mystery');
  if (storedData) {
    let parsedData = JSON.parse(storedData);
    for (let key in parsedData) {
      if (document.querySelector(`input[data-id="${key}"]`)) {
          document.querySelector(`input[data-id="${key}"]`).checked = parsedData[key];
          document.querySelector(`input[data-forminputid="${key}"]`).value = parsedData[key] ? 1 : 0;         
      }
    }                               
  }

});

document.addEventListener('variant:added', function(event) {
  var storedData = sessionStorage.getItem('mystery');
    if (storedData) {
      sessionStorage.removeItem('mystery');
    }
});


function handleMysteryHistory(item,value) {
  var storedData = sessionStorage.getItem('mystery'),
      i = 0;
  if (storedData) {
    let parsedData = JSON.parse(storedData);
    for (let key in parsedData) {
      if (key === item) {
        parsedData[key] = value;
        i++;
      }
    }
    if (i > 0) {
        const modifyed = JSON.stringify(parsedData);
        sessionStorage.setItem('mystery', modifyed);      
    } else {
        parsedData[item] = value;
        const updated = JSON.stringify(parsedData);
        sessionStorage.setItem('mystery', updated);
    }
  } else {
    const mystery = {
      [item]: value
    };
    const jsonObject = JSON.stringify(mystery);
    sessionStorage.setItem('mystery', jsonObject);
  }  
}

function changeMysteryBoxQuantity(checkbox,input) {
  if (document.querySelector(checkbox) !== null) {
    if (document.querySelector(checkbox).checked == true) {
      document.querySelector(input).value = 1;
      handleMysteryHistory(document.querySelector(checkbox).dataset.id,true);
    } else {
      document.querySelector(input).value = 0;
      handleMysteryHistory(document.querySelector(checkbox).dataset.id,false);
    }
  }
}

function hotStockRandom(hotStock) {
  if (hotStock) {
      var numbersProductList = hotStock.dataset.hotStock.toString().split(','),
          numbersProductItem = Math.floor(Math.random() * numbersProductList.length);
      hotStock.querySelector('.hot-stock-progress-item span').innerHTML = numbersProductList[numbersProductItem] + '% ';
      hotStock.querySelector('.hot-stock-progress-item').style.width = numbersProductList[numbersProductItem] + '%';
  }
}

function showStikycustomize() {
  let startModal = document.getElementById('data-select-template-modal-start-button');
  if (startModal) {
    let stickyNude = document.getElementById('nude-customize');
    let stickyAtcPrice = document.getElementById('atc-price');
    if (stickyAtcPrice) {
      stickyAtcPrice.style.display = 'none';
    }
    if (stickyNude) {
      stickyNude.style.display = 'block';
      stickyNude.addEventListener('click', (event) => {
        startModal.click();
      })
    }
  }
}


window.addEventListener("DOMContentLoaded", (event) => {
  showStikycustomize();
  hotStockRandom(document.querySelector('.product__hot-stock'));

  if (document.querySelector("#AddToCart"))
    document.querySelector("#AddToCart").style.pointerEvents = "auto";
  if (document.querySelector("#StickyAddToCart"))
    document.querySelector("#StickyAddToCart").style.pointerEvents = "auto";
  let userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;
  let safariAgent = userAgentString.indexOf("Safari") > -1;
  if ((chromeAgent) && (safariAgent)) { 
    safariAgent = false;
  }
  if (safariAgent == true && window.innerWidth < 430) {
    document.querySelectorAll(".variant-name-holder").forEach((element) => { element.style.fontSize = "12px"; element.style.fontWeight = "500"; })
  }
});

function showProductMoreInfo(element) {
  if (element.closest(".screen-shield__option"))
    element.closest(".screen-shield__option").classList.toggle("variant-info__case-show-info--shown");
  if (element.closest(".accessories__option"))
    element.closest(".accessories__option").classList.toggle("variant-info__case-show-info--shown");
  if (element.closest(".block-swatch"))
    element.closest(".block-swatch").classList.toggle("variant-info__case-show-info--shown");
}

async function handleDiscountCode() {
  let discountCodeToAdd = document.querySelector("#phantom-checkout-button")?.getAttribute("discount-code");
  if (discountCodeToAdd)
    await fetch("/discount/" + discountCodeToAdd);
  if (document.querySelector("#mini-cart [form='mini-cart-form']"))
    document.querySelector("#mini-cart [form='mini-cart-form']").click();
  else
    window.location.href = "/checkout";
}
function showCaseType(element) {
  const group = element.closest(".case-type-group");
  const checkedGroup = element.closest(".case-type-group:has(.block-swatch__radio:checked)");
  if (!checkedGroup) {
    group.querySelector('.block-swatch input').click();
  }/*
  if (element.closest(".case-type-group"))
    element.closest(".case-type-group").classList.toggle("show-case-type-group");*/
    /*element.querySelectorAll(".block-swatch").forEach((elem) => elem.classList.toggle("show-case-type-group");*/
}

//new modification
/*
Show the variants with the given index list, remove the 'selected' class from the main case selector, add it to the selected,
then fire click event for the given variant selector id
selectedItem: HTMLElement;
id: string; (id to select);
*/
function selectVariantManually(selectedItem, id) {
  document.querySelector('.magsafe-selector__wrapper .selected').classList.remove('selected');
  selectedItem.classList.add("selected");
  document.getElementById(id)?.click();
}


// Read case type variant data from Liquid-generated JSON
function getMagsafeVariantsData() {
  const scriptTag = document.getElementById('magsafe-variants-data');
  if (!scriptTag) return null;
  try {
    return JSON.parse(scriptTag.textContent);
  } catch (e) {
    return null;
  }
}

// Show/hide .block-swatch-list.case-type.variant-design and .magsafe-heading
// based on whether any MagSafe variant of the selected case type's group is available globally.
// e.g. if selectedCaseType is "Full-Shock" or "Full-Shock MagSafe", checks for any "Full-Shock MagSafe" available.
function updateMagsafeGroupVisibility(selectedCaseType) {
  const caseTypeList = document.querySelector('.block-swatch-list.case-type.variant-design');
  const magSafeTitle = document.querySelector('.magsafe-heading');

  const variants = getMagsafeVariantsData();
  if (!variants) return;

  // Strip " MagSafe" to get the base group name, then look for any available MagSafe variant in that group
  const baseCaseType = selectedCaseType.replace(' MagSafe', '').trim();
  const magsafeCaseType = baseCaseType + ' MagSafe';

  const hasMagsafe = variants.some(function(v) {
    return v.caseType === magsafeCaseType && v.available;
  });

  if (caseTypeList) caseTypeList.style.display = hasMagsafe ? '' : 'none';
  if (magSafeTitle) magSafeTitle.style.display = hasMagsafe ? '' : 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  // Read initial case type from the checked option1 radio on page load
  const initialCaseType = document.querySelector('input[name="option1"]:checked')?.value ?? null;
  if (initialCaseType) updateMagsafeGroupVisibility(initialCaseType);

  const productVariantsEl = document.querySelector('product-variants');
  if (!productVariantsEl) return;

  const formId = productVariantsEl.getAttribute('form-id');
  const form = document.getElementById(formId);
  if (!form) return;

  form.addEventListener('variant:changed', function(event) {
    const variant = event.detail?.variant;
    if (variant) {
      updateMagsafeGroupVisibility(variant.options[0]);
    } else {
      const caseTypeList = document.querySelector('.block-swatch-list.case-type.variant-design');
      const magSafeTitle = document.querySelector('.magsafe-heading');
      if (caseTypeList) caseTypeList.style.display = 'none';
      if (magSafeTitle) magSafeTitle.style.display = 'none';
    }
  });
});

//new modification end

function updateAccessoryCheckedStates() {
  const wrapper = document.querySelector('.accessories__wrapper');
  if (!wrapper) return;
  wrapper.querySelectorAll('.accessories__input').forEach(function(checkbox) {
    const option = checkbox.closest('.accessories__option');
    if (!option) return;
    if (checkbox.checked) {
      option.classList.add('accessory-checked');
    } else {
      option.classList.remove('accessory-checked');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  updateAccessoryCheckedStates();
  document.addEventListener('click', function(event) {
    if (event.target.matches('.accessories__input')) {
      updateAccessoryCheckedStates();
    }
  });
});


// ─── Global Cart Update Listener ───────────────────────────────────────────
// Ensures header cart count updates whenever cart:updated event fires
document.addEventListener('cart:updated', function(event) {
  if (event.detail && event.detail.cart && event.detail.cart.item_count !== undefined) {
    const itemCount = event.detail.cart.item_count;
    
    // Update all cart count elements (fallback for header)
    const cartCountElements = document.querySelectorAll('.header__cart-count, [data-cart-count]');
    cartCountElements.forEach(el => {
      el.textContent = itemCount;
      // Remove visually-hidden class when cart has items
      if (itemCount > 0) {
        el.classList.remove('visually-hidden');
      } else {
        el.classList.add('visually-hidden');
      }
    });
    
    console.log('Global cart update: item count =', itemCount);
  }
});